import { useState } from 'react';
import { createOrg } from '../../../util/util';
import useFieldErrors from '../../../hooks/useFieldErrors';
import ExpandableTextarea from '../ui/ExpandableTextarea';
import Modal from './Modal';
import ModalActions from './ModalActions';
import FormField, { TextField } from '../ui/FormField';
import { useToast } from '../../ui/Toast';

function OrgCreateModal({ isModalOpen, setIsModalOpen, onOrgCreated }) {
  const { showSuccess, showError } = useToast();
  const { errors, setErrors, clearError } = useFieldErrors();
  const [isSaving, setIsSaving] = useState(false);
  const [bio, setBio] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    if (isSaving) return;
    const formData = new FormData(e.target);

    const orgName = formData.get('orgName')?.trim();
    if (!orgName) {
      setErrors({ orgName: 'Please enter an organization name' });
      return;
    }
    setErrors({});

    const orgData = {
      org_name: orgName,
      org_name_merge: orgName,
      bio: formData.get('bio')?.trim() || null,
      show_count: 0,
      is_created: true,
    };

    setIsSaving(true);
    try {
      const created = await createOrg(orgData);
      if (created) {
        onOrgCreated?.(created);
      }
      setIsModalOpen(false);
      setBio('');
      showSuccess('Organization created.');
    } catch (error) {
      console.error('Error creating org:', error);
      showError(`Failed to create organization: ${error.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    if (isSaving) return;
    setIsModalOpen(false);
    setErrors({});
    setBio('');
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleClose} title="Add Organization">
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4">
          <TextField
            label="Organization Name"
            name="orgName"
            required
            autoFocus
            error={errors.orgName}
            onChange={() => clearError('orgName')}
          />

          <FormField label="Bio" htmlFor="bio">
            <ExpandableTextarea
              id="bio"
              name="bio"
              title="Bio"
              value={bio}
              onChange={e => setBio(e.target.value)}
            />
          </FormField>
        </div>

        <ModalActions onCancel={handleClose} isLoading={isSaving} />
      </form>
    </Modal>
  );
}

export default OrgCreateModal;
